/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ hours: NonNullable<unknown>, unitPrice: NonNullable<unknown> }} Admin_External_Booking_Edit_Order_Summary_Booking_Price_HourInputs */

const en_admin_external_booking_edit_order_summary_booking_price_hour = /** @type {(inputs: Admin_External_Booking_Edit_Order_Summary_Booking_Price_HourInputs) => LocalizedString} */ (i) => {
	if (i?.hours == "1") return /** @type {LocalizedString} */ (`1 hour × ${i?.unitPrice}`);
	return /** @type {LocalizedString} */ (`${i?.hours} hours × ${i?.unitPrice}`)
	
};

const de_admin_external_booking_edit_order_summary_booking_price_hour = /** @type {(inputs: Admin_External_Booking_Edit_Order_Summary_Booking_Price_HourInputs) => LocalizedString} */ (i) => {
	if (i?.hours == "1") return /** @type {LocalizedString} */ (`1 Stunde × ${i?.unitPrice}`);
	return /** @type {LocalizedString} */ (`${i?.hours} Stunden × ${i?.unitPrice}`)
	
};

const es_admin_external_booking_edit_order_summary_booking_price_hour = /** @type {(inputs: Admin_External_Booking_Edit_Order_Summary_Booking_Price_HourInputs) => LocalizedString} */ (i) => {
	if (i?.hours == "1") return /** @type {LocalizedString} */ (`1 hora × ${i?.unitPrice}`);
	return /** @type {LocalizedString} */ (`${i?.hours} horas × ${i?.unitPrice}`)
	
};

const fr_admin_external_booking_edit_order_summary_booking_price_hour = /** @type {(inputs: Admin_External_Booking_Edit_Order_Summary_Booking_Price_HourInputs) => LocalizedString} */ (i) => {
	if (i?.hours == "1") return /** @type {LocalizedString} */ (`1 heure × ${i?.unitPrice}`);
	return /** @type {LocalizedString} */ (`${i?.hours} heures × ${i?.unitPrice}`)
	
};

const nl_admin_external_booking_edit_order_summary_booking_price_hour = /** @type {(inputs: Admin_External_Booking_Edit_Order_Summary_Booking_Price_HourInputs) => LocalizedString} */ (i) => {
	if (i?.hours == "1") return /** @type {LocalizedString} */ (`1 uur × ${i?.unitPrice}`);
	return /** @type {LocalizedString} */ (`${i?.hours} uur × ${i?.unitPrice}`)
	
};

const it_admin_external_booking_edit_order_summary_booking_price_hour = /** @type {(inputs: Admin_External_Booking_Edit_Order_Summary_Booking_Price_HourInputs) => LocalizedString} */ (i) => {
	if (i?.hours == "1") return /** @type {LocalizedString} */ (`1 ora × ${i?.unitPrice}`);
	return /** @type {LocalizedString} */ (`${i?.hours} ore × ${i?.unitPrice}`)
	
};

const pt_br2_admin_external_booking_edit_order_summary_booking_price_hour = /** @type {(inputs: Admin_External_Booking_Edit_Order_Summary_Booking_Price_HourInputs) => LocalizedString} */ (i) => {
	if (i?.hours == "1") return /** @type {LocalizedString} */ (`1 hora × ${i?.unitPrice}`);
	return /** @type {LocalizedString} */ (`${i?.hours} horas × ${i?.unitPrice}`)
	
};

const pl_admin_external_booking_edit_order_summary_booking_price_hour = /** @type {(inputs: Admin_External_Booking_Edit_Order_Summary_Booking_Price_HourInputs) => LocalizedString} */ (i) => {
	if (i?.hours == "1") return /** @type {LocalizedString} */ (`1 godzina × ${i?.unitPrice}`);
	return /** @type {LocalizedString} */ (`${i?.hours} godz. × ${i?.unitPrice}`)
	
};

const hu_admin_external_booking_edit_order_summary_booking_price_hour = /** @type {(inputs: Admin_External_Booking_Edit_Order_Summary_Booking_Price_HourInputs) => LocalizedString} */ (i) => {
	if (i?.hours == "1") return /** @type {LocalizedString} */ (`1 óra × ${i?.unitPrice}`);
	return /** @type {LocalizedString} */ (`${i?.hours} óra × ${i?.unitPrice}`)
	
};

const ro_admin_external_booking_edit_order_summary_booking_price_hour = /** @type {(inputs: Admin_External_Booking_Edit_Order_Summary_Booking_Price_HourInputs) => LocalizedString} */ (i) => {
	if (i?.hours == "1") return /** @type {LocalizedString} */ (`1 oră × ${i?.unitPrice}`);
	return /** @type {LocalizedString} */ (`${i?.hours} ore × ${i?.unitPrice}`)
	
};

/**
* | hours | output |
* | --- | --- |
* | "1" | "1 hour × {unitPrice}" |
* | * | "{hours} hours × {unitPrice}" |
*
* @param {Admin_External_Booking_Edit_Order_Summary_Booking_Price_HourInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_external_booking_edit_order_summary_booking_price_hour = /** @type {((inputs: Admin_External_Booking_Edit_Order_Summary_Booking_Price_HourInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_External_Booking_Edit_Order_Summary_Booking_Price_HourInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_external_booking_edit_order_summary_booking_price_hour(inputs)
	if (locale === "de") return de_admin_external_booking_edit_order_summary_booking_price_hour(inputs)
	if (locale === "es") return es_admin_external_booking_edit_order_summary_booking_price_hour(inputs)
	if (locale === "fr") return fr_admin_external_booking_edit_order_summary_booking_price_hour(inputs)
	if (locale === "nl") return nl_admin_external_booking_edit_order_summary_booking_price_hour(inputs)
	if (locale === "it") return it_admin_external_booking_edit_order_summary_booking_price_hour(inputs)
	if (locale === "pt-BR") return pt_br2_admin_external_booking_edit_order_summary_booking_price_hour(inputs)
	if (locale === "pl") return pl_admin_external_booking_edit_order_summary_booking_price_hour(inputs)
	if (locale === "hu") return hu_admin_external_booking_edit_order_summary_booking_price_hour(inputs)
	return ro_admin_external_booking_edit_order_summary_booking_price_hour(inputs)
});
export { admin_external_booking_edit_order_summary_booking_price_hour as "admin.external_booking_edit.order_summary.booking_price_hour" }